import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { nanoid } from "@reduxjs/toolkit";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
import * as actions from "../../slices/master/getAddressDistrict.slice";
export var getAddressDistrict = function() {
    var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var requestId, key, _result_data, result, _result_data_data, rows, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestId = nanoid();
                        key = JSON.stringify([
                            payload.provinceid,
                            payload.districtid
                        ]);
                        dispatch(actions.fetchData({
                            key: key,
                            requestId: requestId
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            http({
                                method: "get",
                                url: endPoint.DISTRICT_URL,
                                headers: {
                                    Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
                                },
                                params: payload
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        rows = (_result_data_data = result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.data) !== null && _result_data_data !== void 0 ? _result_data_data : result === null || result === void 0 ? void 0 : result.data;
                        if (!Array.isArray(rows)) throw new Error("Invalid address response");
                        dispatch(actions.fetchDataSuccess({
                            requestId: requestId,
                            data: rows
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dispatch(actions.fetchDataFailure({
                            requestId: requestId
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var clearGetAddressDistrict = function() {
    return function(dispatch) {
        return dispatch(actions.resetState());
    };
};
